<!-- 
  @license lucide-svelte v0.303.0 - ISC

This source code is licensed under the ISC license.
See the LICENSE file in the root directory of this source tree. 
-->

<script>import Icon from '../Icon.svelte';
const iconNode = [["polygon", { "points": "5 3 19 12 5 21 5 3" }]];
</script>

<Icon name="play" {...$$props} iconNode={iconNode}>
  <slot/>
</Icon>
